
const selectors = {
    pageWrapper: "#cart-container",
    checkoutBtn: 'cart-overview-footer',
    stickyCart: '.cart__sticky',
    deliveryForm: ".delivery-estimates__form",
    deliveryResults: ".delivery-estimates__results",
    cartItems: "#cartItems",
    buttons: {
        checkout: '[js-cart="checkout"]',
        container: '[js-cart="container"]',
        discounts: '[js-cart="discounts"]',
        panel: '[js-cart="panel"]',
        sidebar: '[js-cart-sidebar="container"]',
        sidebarInner: '[js-cart-sidebar="inner"]',
        sticky: '[js-cart="sticky"]',
        subtotal: '[js-cart="subtotal"]',
        total: '[js-cart="total"]'
    },
    deliveryEstimatesSelectors: {
        container: '[js-delivery-estimates="container"]',
        form: '[js-delivery-estimates="form"]',
        input: '[js-delivery-estimates="input"]',
        button: '[js-delivery-estimates="button"]',
        results: '[js-delivery-estimates="results"]',
        cartPrice: '[js-cart="total"]'
    },
}

const modifiers = {
        active: 'is-active',
        added: 'is-added',
        adding: 'is-adding',
        collapsed: 'is-collapsed',
        condensed: 'is-condensed',
        disabled: 'is-disabled',
        empty: 'is-empty',
        ended: 'is-ended',
        hidden: 'is-hidden',
        invalid: 'is-invalid',
        lazyload: 'lazyload',
        lazyloaded: 'lazyloaded',
        lazyloading: 'lazyloading',
        loading: 'is-loading',
        locked: 'is-locked',
        minimised: 'is-minimised',
        pagination: 'has-pagination',
        paused: 'is-paused',
        playing: 'is-playing',
        removed: 'is-removed',
        removing: 'is-removing',
        rendering: 'is-rendering',
        searching: 'is-searching',
        sticky: 'is-sticky',
        tabbable: 'is-tabbable',
        transitioning: 'is-transitioning',
        transparent: 'is-transparent',
        visible: 'is-visible',
        zoomed: 'is-zoomed'
}


function initCartPageFunctionality() {
    const wrapper = document.querySelector(selectors.pageWrapper);

    if(!wrapper) return;

    const getNodeSelectors = (selectors) => {
        return {
            container: document.querySelector(selectors.container),
            panel: document.querySelector(selectors.panel),
            checkout: document.querySelector(selectors.checkout),
            sticky: document.querySelector(selectors.sticky)
        }
    }

    const setInterseptionObserver = (element, callback, threshold = 0.5) => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold
        }

        const observer = new IntersectionObserver(callback, options)
        observer.observe(element)
    }
    const initIntersectionObserver = () => {
        const element = document.getElementById(selectors.checkoutBtn);
        const checkout = document.querySelector(selectors.buttons.checkout)
        
        setInterseptionObserver(checkout, handleIntersection)
    }

    const handleIntersection = (entries) => {
        // passed to Utilities.setIntersectionObserver as a callback, loses scope of `Cart instance`
        const nodeSelectors = getNodeSelectors(selectors.buttons)

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (nodeSelectors.sticky) {
                    nodeSelectors.sticky.classList.remove(modifiers.active)
                }
                return
            }

            if (nodeSelectors.sticky) {
                nodeSelectors.sticky.classList.add(modifiers.active)
            }
        })
    }

    const enebleDeliveryMessege = () => {
            const form = document.querySelector(selectors.deliveryForm);
            const input = form.querySelector('input');
            const results = document.querySelector(selectors.deliveryResults);
            const cartItems = JSON.parse(document.querySelector(selectors.cartItems).innerHTML);

            /* eslint-disable babel/camelcase */
            var postalCode = void 0;
            if (input && input.value && input.value.trim()) {
                postalCode = input.value.trim();
            }

            results.innerHTML = '';
            results.classList.remove(modifiers.hidden);
            results.classList.add(modifiers.loading);

            /**
             * Fulfilment service hard-coded as manual.
             */
            var items = cartItems.items.map(function (item) {
                return {
                    variant_id: item.variant_id,
                    fulfillment_service: 'manual',
                    quantity: item.quantity,
                    grams: item.grams,
                    price: item.price
                };
            });
            
            var country = window.theme.currency === 'GBP' ? 'GB' : 'IE';

            /**
             * If ASR is in test mode, we need to pass name with `Bambri` value.
             */
            var asrTestMode = void 0;
            if (window.theme.api && window.theme.api.asrTestMode) {
                asrTestMode = window.theme.api.asrTestMode;
            }
            const data = {
                destination: {
                    country,
                    postal_code: postalCode,
                    ...(asrTestMode && {
                        name: 'Bambri'
                    })
                },
                items
            }
                /* eslint-enable babel/camelcase */
            fetch('https://api.advancedshippingrules.com/rates', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${window.theme.api.asrToken}`
                },
                body: JSON.stringify(data)
            })
                .then((rates) => rates.json())
                .then((rates) => {
                    if (rates.error) {
                        renderResultsError('noRates')
                        throw Error('No rates found!')
                    }
    
                    renderResults(rates, postalCode)
                })
                .catch((error) => {
                    renderResultsError('noRatesLoadError')
                    throw Error('Failed to load rates', error)
                })
    }

    const renderResults = (rates, postalCode) => {
        document.querySelector(selectors.deliveryEstimatesSelectors.results).classList.remove(modifiers.loading)
        document.querySelector(selectors.deliveryEstimatesSelectors.results).classList.remove(modifiers.hidden)

        const cheapestRate = rates
            .filter((item) => typeof item.total_price === 'number')
            .sort((rate1, rate2) => rate1.total_price - rate2.total_price)[0]

        const label = window.theme.deliveryEstimates.deliveryTo.replace('%postcode%',postalCode.toUpperCase())

        const price =
            cheapestRate.total_price === 0
                ? window.theme.deliveryEstimates.free
                : formatMoney(cheapestRate.total_price, window.theme.moneyFormat)

        const priceString =
            rates.length > 1
                ? window.theme.deliveryEstimates.from.replace(
                    '%price%', price)
                : price

        document.querySelector(selectors.deliveryEstimatesSelectors.results).innerHTML = `
        <span class="delivery-estimates__label">${label}</span>
        <span class="delivery-estimates__price">${priceString}</span>
    `

        updateTotalPrice(cheapestRate.total_price)
    }

    const renderResultsError = (error) => {
        document.querySelector(selectors.deliveryEstimatesSelectors.results).classList.remove(modifiers.loading)
        document.querySelector(selectors.deliveryEstimatesSelectors.results).classList.remove(modifiers.hidden)

        let errorString = window.theme.deliveryEstimates.invalid

        if (error === 'noRates') {
            errorString = window.theme.deliveryEstimates.noRates
        }

        if (error === 'noRatesLoadError') {
            document.querySelector(selectors.deliveryEstimatesSelectors.results).classList.add(modifiers.hidden)
        }

        document.querySelector(selectors.deliveryEstimatesSelectors.results).innerHTML = `<span class="delivery-estimates__error">${errorString}</span>`

        updateTotalPrice()
    }
    const updateTotalPrice = (rate = 0) => {
        window.cart.get().then((response) => {
            const newTotal = response.total_price + rate
            document.querySelector(selectors.deliveryEstimatesSelectors.cartPrice).querySelector('#revy-cart-subtotal-price').innerHTML = formatMoney(newTotal,window.theme.moneyFormat)
        });
    }

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
      
        function formatWithDelimiters(
          number,
          precision = 2,
          thousands = ',',
          decimal = '.'
        ) {
          if (isNaN(number) || number == null) {
            return 0;
          }
      
          number = (number / 100.0).toFixed(precision);
      
          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
          );
          const centsAmount = parts[1] ? decimal + parts[1] : '';
      
          return dollarsAmount + centsAmount;
        }
      
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
      
        return formatString.replace(placeholderRegex, value);
    }

    const checkInput = () => {
        const form = document.querySelector(selectors.deliveryForm);
        const input = form.querySelector('input');

        /* eslint-disable babel/camelcase */
        var postalCode = void 0;
        if (input && input.value && !input.value.trim()) {
            return
        }

        document.querySelector(selectors.deliveryEstimatesSelectors.button).removeAttribute('disabled')
    }

    const onInitDeliveryMessage = () => {
        if(document.querySelector(selectors.deliveryEstimatesSelectors.container)) {
            document.querySelector(selectors.deliveryEstimatesSelectors.container).classList.remove(modifiers.hidden);
            checkInput();
            setEventListeners();
        }
    }

    const setEventListeners = () => {
        const form = document.querySelector(selectors.deliveryForm);
        const input = form.querySelector('input');

        input.addEventListener('input', () => {
            if (input && input.value && input.value.trim()) {
                document.querySelector(selectors.deliveryEstimatesSelectors.button).removeAttribute('disabled')
                return
            }

            document.querySelector(selectors.deliveryEstimatesSelectors.button).setAttribute('disabled', 'disabled')
        })

        form.addEventListener('submit', (event) => {
            event.preventDefault()
            event.stopPropagation()
            enebleDeliveryMessege()
        })
    }

    initIntersectionObserver();
    onInitDeliveryMessage();
}


document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector('#cart-container');
    if (wrapper) {
        initCartPageFunctionality()
    }
}
)